import config from '../config'
import keycloak from '../keycloak'
import { refreshAccessToken } from './apiClient'

// Streaming downloads and payment redirects still use the backend's token query
// parameter. Read it only from memory, after refresh, immediately before navigation.
export const getAuthenticatedApiUrl = async (
  path: string,
  params: Record<string, string> = {},
): Promise<string> => {
  const baseUrl = new URL('api/', config.apiUrl)
  const url = new URL(path, baseUrl)
  if (url.origin !== baseUrl.origin || !url.pathname.startsWith(baseUrl.pathname)) {
    throw new Error('Invalid API URL')
  }

  const refreshed = await refreshAccessToken(60)
  if (!refreshed || !keycloak.token) {
    throw new Error('Please sign in again.')
  }

  Object.entries(params).forEach(([name, value]) => url.searchParams.set(name, value))
  url.searchParams.set('token', keycloak.token)
  return url.toString()
}
